/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarSquareRegularType from './calendar-square-regular-type-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarSquareRegularType {...validProps} />;
}

SvgComponent.iconName = 'calendarSquareRegularType';

export const CalendarSquareRegularTypeIcon = svgIconWrapper(SvgComponent);
